import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

// Panel-owned data - reset by resetPanelState when the citizen enters a different
// panel. Common-service data (commonObj / commonObjCommonConfig) is never reset.
const defaultTraineeTranerObj = () => ({
  hasDropdownLoaded: false,
  roomTypeList: [],
  roomRentList: [],
  roomList: [],
  floorList: [],
  trainingTypeList: [],
  trainingCategoryList: [],
  trainingTitleList: [],
  courseList: [],
  courseModuleList: [],
  courseDocumentSetupList: [],
  trainerEvaluationList: [],
  faqSetupList: [],
  // personalInfoList: [],
  gradingStatus: [],
  trainingReportHeadList: [],
  trainingExpertiseList: [],
  jobTypeList: Custom.jobTypeList,
  driverList: [],
  guestHouseList: [],
  accomodationSetupList: []
})

// Full default state - restored by resetExternalState on admin/office login
const defaultState = () => ({
    traineeTranerObj: defaultTraineeTranerObj(),
    trainerOrTrainee: null,
    static: {
        perPage: 10,
        dateFormat: 'DD/MM/YYYY',
        fiscaleYear: 'YYYY-YYYY',
        timeFormat: 'h:m',
        loading: false,
        listReload: false,
        hasDropdownLoaded: false
    }
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPanelState (state) {
      state.traineeTranerObj = defaultTraineeTranerObj()
      state.trainerOrTrainee = null
    },
    resetExternalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
